module.exports = __webpack_public_path__ + "img/一键美颜--低端机适配.c503b880.png";